import React from "react";
import { useTranslation } from "react-i18next";
import { GridList, Loader } from "@monorepo/components";
import { convertNumberToCurrency } from "@monorepo/helpers";
import theme from "@monorepo/styles/theme";
import { Box, styled, Typography } from "@mui/material";

interface IProps {
  discount?: string | number;
  sum?: string | number;
  isFetchingDiscount?: boolean;
  commission?: string | number;
}

const PaymentSumBlock = styled(Box)(() => ({
  display: "grid",
  gridRowGap: theme.spacing(3),
  alignItems: "center",
  textAlign: "center",
}));

const PaymentItem = ({ label, value, isLoading }: { label: string; value?: string | number; isLoading?: boolean }) => (
  <PaymentSumBlock>
    <Typography component="span" sx={{ color: theme.palette.text.disabled }}>
      {label}
    </Typography>
    {isLoading ? (
      <Loader />
    ) : (
      value && (
        <Typography component="strong" fontWeight="bold">
          {convertNumberToCurrency(+value)}
        </Typography>
      )
    )}
  </PaymentSumBlock>
);

const PaymentSumsBox: React.FC<IProps> = ({ discount, sum, commission, isFetchingDiscount = false }) => {
  const { t } = useTranslation();
  const items = [
    { label: t("payments.discount"), value: discount, isLoading: isFetchingDiscount },
    { label: t("payments.sum"), value: sum },
    { label: t("payments.commission"), value: commission },
  ]
    .filter((item) => item.value)
    .map((item) => <PaymentItem key={item.label} {...item} />);

  return <GridList items={items} />;
};

export default PaymentSumsBox;
